module.exports = __webpack_public_path__ + "components/flag/static/square/mh-f73cd4ff6a973c4194632c08f768bee1.svg";